<template>
  <div v-if="isAuthenticated && topicBookmarks.length" class="notes">
    <div class="notes__trigger-wrapper">
      <div class="notes__trigger" @click="isBookmarksShown = !isBookmarksShown">
        <div class="notes__trigger--text">
          Bookmarks: {{ bookmarks.length }}
        </div>
      </div>
    </div>
    <div class="notes__note-wrapper">
      <div
        v-for="video in videosWithBookmarks"
        :key="video.id"
        class="notes__notes"
      >
        <div class="notes__note--video">{{ video.name }}</div>
        <div
          v-for="note in video.bookmarks"
          :key="note.id"
          class="notes__note"
          @mouseover="updateCurrentHover(note.video)"
          @mouseleave="updateCurrentHover('')"
        >
          <NoteIndicator class="notes__note--icon" />
          <div class="notes__note-btn" @click="loadBookmark(note)">
            <span class="notes__note-btn--time">{{
              $duration.mmss(note.time)
            }}</span>
            <span class="notes__note-btn--text"> - {{ note.notes }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import NoteIndicator from '@/assets/icons/course/note_indicator.svg'

export default {
  name: 'Notes',
  components: {
    NoteIndicator: { ...NoteIndicator, name: 'NoteIndicator' },
  },
  props: {
    content: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isBookmarksShown: false,
      videosWithBookmarks: [],
    }
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      currentVideos: state => state.content.currentVideos,
      currentHoveredNote: state => state.content.currentHoveredNote,
      currentCourseId: state => state.courses.currentCourse.id,
    }),
    ...mapGetters({
      bookmarks: 'content/courseBookmarks',
    }),
    listOfContentVideos() {
      return this.content.map(level => {
        return level.uuid
      })
    },
    videosByUUID() {
      return this.currentVideos.reduce((acc, video) => {
        acc[video.id] = video
        return acc
      }, {})
    },
    topicBookmarks() {
      const topicBookmarks = []
      const { bookmarks, content } = this
      bookmarks.map(bookmark => {
        content.map(level => {
          if (bookmark.video === level.uuid) {
            topicBookmarks.push(bookmark)
          }
        })
      })
      return topicBookmarks
    },
  },
  watch: {
    bookmarks() {
      this.setVideosWithBookmarks()
    },
  },
  mounted() {
    this.setVideosWithBookmarks()
  },
  methods: {
    loadBookmark(bookmark) {
      if (bookmark.video === this.playingVideoId) {
        this.$store.dispatch('content/setPlayingVideoTime', bookmark.time)
      } else {
        this.$store.dispatch('content/setPlayingVideoTime', bookmark.time)
        this.$store.dispatch('content/setPlayingVideoId', bookmark.video)
      }
    },
    updateCurrentHover(id) {
      this.$store.dispatch('content/setCurrentHoveredNote', id)
    },
    setVideosWithBookmarks() {
      this.videosWithBookmarks = this.listOfContentVideos.reduce(
        (acc, videoUUID) => {
          const bookmarksVideos = this.topicBookmarks
            .filter(
              b =>
                b.video === videoUUID &&
                b.metadata.course_id === this.currentCourseId
            )
            .sort((a, b) => a.time - b.time)
          if (bookmarksVideos?.length) {
            acc.push({
              ...this.videosByUUID[videoUUID],
              bookmarks: bookmarksVideos,
            })
          }
          return acc
        },
        []
      )
      if (this.videosWithBookmarks?.length) {
        this.$store.dispatch(
          'content/saveVideosWithBookmarks',
          this.videosWithBookmarks
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.notes {
  position: relative;
  $this: &;
  color: var(--white);
  margin: 30px 0 35px 0;
  &__trigger-wrapper {
    width: 100%;
    margin: 10px auto;
  }
  &__trigger {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: transparent;
    border: none;
    margin: 0;
    &:hover {
      cursor: pointer;
      opacity: 0.3;
    }
  }
  &__notes {
    margin-bottom: 15px;
  }
  &__note {
    display: flex;
    color: var(--white);
    font-size: rem(12px);
    align-content: center;
    align-items: flex-start;
    margin-bottom: 20px;
    &--icon {
      fill: var(--yellow);
      flex: 0 0 auto;
    }
    &--video {
      font-size: rem(14px);
      margin-bottom: 10px;
    }
  }
  &__note-btn {
    background: transparent;
    border: none;
    text-align: left;
    color: var(--white);
    padding-left: 10px;
    cursor: pointer;
    line-height: 17px;
    &--time {
      color: var(--white);
    }
    &--text {
      color: var(--light-blue-gray);
    }
    &:hover {
      #{$this}__note-btn--icon {
        color: var(--orange);
      }
    }
  }
}
</style>
